import React, {Component} from 'react';
import {Accordion, Dropdown, Grid, Input} from "semantic-ui-react";
import Settings from "../settings/Settings";

export default class CharGrid extends Component {
    constructor(insert) {
        super();
        this.state = {active: false, chars: [], pres: ""};
    }

    chars;

    async getAllKbd() {
        if (this.state.chars.length === 0) {
            const response = await fetch(Settings.load("server") + '/allChars', {method: 'POST'});
            this.chars = await response.json();
            this.setState({chars: this.chars});
        }
    }

    handleClick = (e, titleProps) => {
        this.setState({active: !this.state.active});
    };

    componentDidUpdate(prevProps) {
        if (this.props.active !== prevProps.active) {
            var that = this;
            this.setState({active: !this.state.active}, function () {
                if (this.state.active) {
                    that.getAllKbd();
                }
            });
        }
    }

    textChanged(e, t) {
        this.setState({chars: this.chars.filter(item => (item.frivolaChar.indexOf(t.value) !== -1 || item.frivolaHex.indexOf(t.value) !== -1 || t.value.length === 0))});
    }

    render() {
        //const a = ["a", "b", "c", "a", "b", "c", "a", "a", "b", "a", "b", "c", "a", "b", "c", "a", "a", "b", "a", "b", "c", "a", "b", "c", "a", "a", "b", "a", "b", "c", "a", "b", "c", "a", "a", "b", "a", "b", "c", "a", "b", "c", "a", "a", "b", "c", "a", "b", "c", "a", "a", "b", "c", "a", "b", "c", "a", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "a", "b", "c", "d"];
        const that = this;
        const options = [
            {key: '0', text: 'vsi', value: 'vsi'},
            {key: '1', text: '', value: 'zgoraj'},
            {key: '2', text: '', value: 'spodaj'}
        ]
        return (
            <Accordion style={{height: "100%"}}>
                <Accordion.Title style={{textAlign: "left", padding: "0"}} active={false}>
                </Accordion.Title>
                <Accordion.Content style={{maxHeight: "200px", height: "100%"}} active={this.state.active}>
                    <div style={{display: "flex", flexDirection: "row"}}>
                        <div style={{flex: 1}}>
                            <div style={{padding: "0", marginBottom: "10px", textAlign: "left"}}>
                                <Input
                                    style={{width: "60%", paddingLeft: "10px"}}
                                    onChange={this.textChanged.bind(this)}
                                    action={<Dropdown button basic floating options={options} defaultValue='vsi'/>}
                                    icon='search'
                                    iconPosition='left'
                                />
                            </div>
                        </div>
                        <div style={{fontSize: "2em", flex: 1, lineHeight: "35px"}}>
                            {this.state.pres}
                        </div>
                    </div>
                    <Grid style={{maxHeight: "120px", overflow: "auto", margin: "10px"}}>
                        {
                            this.state.chars.map(function (d, i) {
                                return (<Grid.Column key={i} style={{fontSize: "2.4em"}}>
                                    <div hex={d.frivolaHex} onMouseOver={that.onHover.bind(that)}
                                       onClick={(a) => that.props.back(a.target.innerHTML)}>{d.frivolaChar}</div>
                                </Grid.Column>)
                            })
                        }
                    </Grid>
                </Accordion.Content>
            </Accordion>
        );
    }

    onHover(e) {
        this.setState({pres: e.target.innerHTML + ": " + e.target.getAttribute('hex')});
    }
}


// WEBPACK FOOTER //
// ./src/components/charGrid/CharGrid.js